module.exports = __webpack_public_path__ + "media/images/default/pages/about/main/flower-field-1a800dcd64eeee9bdce2b11ca3540fb3.jpeg";